import { BaseModel } from "@/models/base/BaseModel";
import { SocialProgramSubscriptionType } from "@/enums/SocialProgramSubscriptionType";
import { PeriodEnum } from "@/enums/PeriodEnum";

export class SocialProgram extends BaseModel {
  lifestyleProgramCategoryId: string;
  lifestyleProgramCategoryName: string;
  description: string;
  imageUrl: string;
  thumbnailUrl: string;
  members: Record<string, string>[];
  membersNames: Record<string, string>[];
  name: string;
  subscriptionPeriod: PeriodEnum;
  subscriptionFeePerDay: string;
  videoId: string;
  type: SocialProgramSubscriptionType;
  price: number;
  residentsPendingMembershipApproval?: string[];

  constructor() {
    super();

    this.description = "";
    this.imageUrl = require("../assets/no-image.jpg");
    this.thumbnailUrl = require("../assets/no-image.jpg");
    this.members = [];
    this.membersNames = [];
    this.name = "";
    this.subscriptionPeriod = PeriodEnum.Day;
    this.subscriptionFeePerDay = "";
    this.videoId = "";
    this.type = SocialProgramSubscriptionType.NonSubscription;
    this.price = 0;
  }
}
